import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationUterusShapeDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusShape/GetDetail?` + params, null);

export const GetRefOBGyExaminationUterusShapeList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusShape/GetList?` + params, null);

export const CreateRefOBGyExaminationUterusShape = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusShape/Create`, data);

export const UpdateRefOBGyExaminationUterusShape = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusShape/Update`, data);

export const DeleteRefOBGyExaminationUterusShape = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusShape/Delete`, data);